<template>
  <div class="catalog-item-create">
    <md-dialog :md-active.sync="dialogVisible" :md-click-outside-to-close="false" class="catalog-item-create__modal">

      <md-dialog-content>
        <md-button @click="closeDialog()" class="md-icon-button catalog-item-create__button--close">
          <md-icon>close</md-icon>
        </md-button>

        <h3 class="catalog-item-create__title">Neues Produkt</h3>
        <div class="catalog-item-create__content">
          <div class="catalog-item-create__field-wrapper--margin-r">
            <catalog-icon-select v-bind:icon.sync="item.icon"></catalog-icon-select>
          </div>
          <form class="md-layout" @submit.prevent="submit">
            <md-field required>
              <label for="name">Bezeichnung</label>
              <md-input name="name" id="name" required v-model="item.name"/>
            </md-field>

            <md-field required>
              <label for="quantity">Quantität</label>
              <md-input name="quantity" id="quantity" v-model="item.quantity"/>
            </md-field>

            <div class="catalog-item-create__field-wrapper catalog-item-create__field-wrapper--small catalog-item-create__field-wrapper--margin-r">
              <md-field required>
                <label for="price">Preis</label>
                <md-input type="number" step="0.01" required name="price" id="price" min="0" v-model="item.price"/>
              </md-field>
            </div>

            <div class="catalog-item-create__field-wrapper catalog-item-create__field-wrapper--small">
              <md-field>
                <label for="mwst">MwSt.</label>
                <md-input type="number" step="0.01" name="mwst" id="mwst" v-model="item.mwst"/>
              </md-field>
            </div>

            <md-field>
              <md-select v-model="item.category" name="category" id="category" placeholder="Kategorie">
                <md-option v-for="category in categories" :value="category.id" :key="category.id">{{category.name}}</md-option>
              </md-select>
            </md-field>

            <div class="catalog-item-create__buttons">
              <button type="submit" :disabled="!validated" class="button catalog-item-create__button catalog-item-create__button--add">Hinzufügen</button>
            </div>

          </form>
        </div>

      </md-dialog-content>
    </md-dialog>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import CatalogIconSelect from './CatalogItemIconSelect'

    export default {
        name: 'CatalogItemCreate',
        components: {
            CatalogIconSelect
        },
        data() {
            return {
                showDialog: true,
                showIconDialog: false,
                showSnackbar: false,
                snackbarMessage: 'Erfolgreich erstellt.',
                item: {
                    name: null,
                    quantity: null,
                    price: null,
                    mwst: null,
                    category: null,
                    location_id: null,
                    icon: null
                }
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('catalog', [
                'categories',
                'showCreateItem'
            ]),
            validated: function () {
                return (this.item.name && this.item.price && this.item.icon && this.item.category)
            },
            dialogVisible: function() {
                return this.showCreateItem && this.showDialog
            }
        },
        mounted() {
            this.item.location_id = this.user.locationId
            this.showDialog = true
        },
        methods: {
            ...mapActions('catalog', [
                'createItem',
                'showCreateItemForm'
            ]),
            closeDialog: function() {
                this.showCreateItemForm(false)
            },
            submit: async function() {
                let payload = {
                    item: this.item,
                    locationId: this.user.locationId
                }
                await this.createItem(payload)
                this.showSnackbar = true
                this.showDialog = false

                // reset input
                this.item.name = null
                this.item.quantity = null
                this.item.price = null
                this.item.mwst = null
                this.item.category = null
                this.item.location_id = null
                this.item.icon = null
            }
        }
    }
</script>